import { Box } from "@mui/material";
import { useEffect } from "react";
import FormType, { FieldConfigs } from "../../../../../shared/components/FormType";
import { Customer } from "../../../../../data/entities";
import { api } from "../../../../../shared/hooks/api";

interface ImportProductFormProps {
    formData: any;
    onChange: (data: any) => void;
}

export const ImportProductForm = ({ formData, onChange }: ImportProductFormProps) => {
    const [{ data: customers }] = api.get<Customer[]>("/customers/", { page: 1, page_size: 1000 });
    const normalizeCustomer = (customer: any) => ({
        ...customer,
        text: customer.text || customer.name || customer.display_name || "",
        value: customer.value || customer.id,
    });

    useEffect(() => {
        if (formData?.customer && customers?.results) {
            let customerToSelect: any = null;

            // If customer is already a full object, use it directly
            if (typeof formData.customer === "object" && formData.customer.id) {
                customerToSelect = formData.customer;
            }
            // If customer is just an ID, find the full customer object
            else if (
                typeof formData.customer === "string" ||
                typeof formData.customer === "number"
            ) {
                customerToSelect = customers.results.find(
                    (c: Customer) => c.id === formData.customer
                );
            }

            if (customerToSelect) {
                const normalizedCustomer = normalizeCustomer(customerToSelect);
                if (
                    formData.customer?.text !== normalizedCustomer.text ||
                    formData.customer?.value !== normalizedCustomer.value ||
                    formData.address !== (normalizedCustomer.address || "")
                ) {
                    onChange({
                        ...formData,
                        customer: normalizedCustomer,
                        address: normalizedCustomer.address || "",
                    });
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData?.customer, customers?.results]);

    const fields: FieldConfigs[] = [
        {
            label: "Người giao",
            type: "text",
            key: "receiver_name",
            required: false,
        },
        {
            label: "Khách hàng",
            key: "customer",
            type: "autocomplete",
            options: customers?.results?.map((customer: Customer) => ({
                ...customer,
                text: customer.name,
                value: customer.id,
            })),
            noDataText: "Không tìm thấy khách hàng",
            required: true,
        },
        {
            label: "Phương thức nhập",
            type: "dropdown",
            key: "import_method",
            required: true,
            options: [
                { text: "Nhập hàng sản xuất", value: "nhập hàng sản xuất" },
                { text: "Nhập hàng trả lại", value: "nhập hàng trả lại" },
                { text: "Khác", value: "khác" },
            ],
        },
        {
            label: "Ngày nhập",
            type: "calendar",
            key: "import_date",
            required: true,
        },
        {
            label: "Ghi chú",
            type: "text",
            key: "note",
            required: false,
        },
    ];

    return (
        <Box sx={{ width: "100%", height: "300px", overflowY: "auto" }}>
            <FormType
                title="Thông tin nhập kho"
                fields={fields}
                validated={false}
                requireData={formData}
                mergeFormData={onChange}
            />
        </Box>
    );
};
